import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { ShaftLengthDigit } from '../../api/models';

export type TABLE_TYPE = Table<ShaftLengthDigit>;

export const TABLE = 'shaftLengthDigit';
const SCHEMA = 'shaftLengthDigitId, sortId';

class ShaftLengthDigitDatabase implements DataRepository<ShaftLengthDigit> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<ShaftLengthDigit | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: ShaftLengthDigit, key: Key): Promise<ShaftLengthDigit> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: ShaftLengthDigit[]): Promise<ShaftLengthDigit[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<ShaftLengthDigit[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const ShaftLengthDigitDB = new ShaftLengthDigitDatabase(db);
